const companyConstants = {
  COMPANY: 'COMPANY'
};

export default companyConstants;
